export default {
  ordersEvents: null,
  orderToUpdate: null,
  productSelected: null,
  deliveryToUpdate: null,
  calendarSelection: null,
  newEventCalendar: null,
};
